module.exports = __webpack_public_path__ + "img/staking_time_btn.5288dd86.png";